import MenuIcon from '@mui/icons-material/Menu';
import { Box, alpha } from '@mui/material';
import { styled } from '@mui/material/styles';
import HeaderButtons from './Buttons';
import HeaderUserbox from './Userbox';
import { IconButton, Toolbar } from 'src/components';
import RouterBreadcrumbs from './Breadcrumbs';
import { useAppDispatch, useAppSelector } from 'src/store';
import { SidebarSlice } from 'src/layouts/contexts/SidebarSlice';
import { useLocation } from 'react-router-dom';
import ImzaliDosyalarSayaci from './ImzaliDosyalarSayaci';

const ModernHeaderWrapper = styled(Box)(
  ({ theme }) => `
    position: relative;
    background: transparent;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  `
);
const ModernToolbar = styled(Toolbar)(
  ({ theme }) => `
    padding: 0 !important;
    min-height: 32px;
    display: flex;
    align-items: stretch;
    gap: 0;
    justify-content: stretch;
    width: 100%;
    box-sizing: border-box;
    background: transparent;
    border-radius: ${theme.shape.borderRadius}px;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    
    @media (max-width: ${theme.breakpoints.values.md}px) {
      min-height: 28px;
    }
`
);
const ModernMenuButton = styled(IconButton)(
  ({ theme }) => `
    width: 28px;
    height: 28px;
    border-radius: 4px;
    background: transparent;
    border: 1px solid ${alpha(theme.palette.divider, 0.1)};
    transition: all 0.2s ease;
    margin-left: 0;
    margin-right: 0;
    
    &:hover {
      background: ${alpha(theme.palette.primary.main, 0.08)};
      border-color: ${alpha(theme.palette.primary.main, 0.2)};
      transform: translateY(-1px);
      box-shadow: 0 1px 4px ${alpha(theme.palette.primary.main, 0.15)};
    }
    
    &:active {
      transform: translateY(0);
    }
    
    .MuiSvgIcon-root {
      font-size: 14px;
      transition: all 0.2s ease;
      color: ${theme.palette.text.primary};
    }
    
    &:hover .MuiSvgIcon-root {
      color: ${theme.palette.primary.main};
    }
`
);
const BreadcrumbsContainer = styled(Box)(
  ({ theme }) => `
    flex: 1;
    display: flex;
    align-items: center;
    min-width: 0;
    height: 28px;
    min-height: 28px;
    margin: 0;
    padding: 0;
    color: ${theme.palette.text.primary};
    
    @media (max-width: ${theme.breakpoints.values.sm}px) {
      margin: 0;
      padding: 0;
    }
`
);

const HeaderActions = styled(Box)(
  ({ theme }) => `
    display: flex;
    align-items: center;
    gap: 2px;
    margin-right: 0;
    min-width: 0;
    padding-right: 0;
  `
);

const Header = (props): JSX.Element => {
  const sidebar = useAppSelector(s => s.sidebar);
  const dispatch = useAppDispatch();
  const location = useLocation();

  const handleMenuToggle = () => {
    dispatch(SidebarSlice.actions.setMobileOpen(!sidebar.mobileOpen));
    dispatch(SidebarSlice.actions.setDesktopOpen(!sidebar.desktopOpen));
  };

  return (
    <ModernHeaderWrapper>
      <ModernToolbar>
        <Box
          display="flex"
          alignItems="center"
          gap={0}
          sx={{
            padding: 0,
            minWidth: 0,
            width: 'auto',
          }}
        >
          <Box sx={{ ml: '0.2rem', height: 28, display: 'flex', alignItems: 'center' }}>
            <ModernMenuButton
              onClick={handleMenuToggle}
              aria-label="Toggle sidebar"
              sx={{
                display: { xs: 'none', sm: "none", md: "none", lg: "flex", xl: "flex" }
              }}
            >
              <MenuIcon />
            </ModernMenuButton>
          </Box>
        </Box>
        <BreadcrumbsContainer sx={{ 
          ml: '1px',
          mt: '1.5px',
          height: 28, 
          display: 'flex', 
          alignItems: 'center',
          justifyContent: 'flex-start'
        }}>
          <RouterBreadcrumbs />
          {localStorage.getItem("lang") === "TR" && (
            <>
              {location.pathname.includes('systems/patoloji-modulu') && (
                <ImzaliDosyalarSayaci />
              )}
            </>
          )}
        </BreadcrumbsContainer>
        <HeaderActions>
          <HeaderButtons />
          <Box sx={{ 
            ml: '1px',
            mr: '1px', 
            width: 160, 
            maxWidth: 160,
            minWidth: 160,
            height: 28, 
            minHeight: 28, 
            display: 'flex', 
            alignItems: 'center',
            overflow: 'hidden'
          }}>
            <HeaderUserbox />
          </Box>
          <Box sx={{ ml: '1px', mr: '0.2rem', height: 28, display: { xs: 'flex', sm: "flex", md: "flex", lg: "none", xl: "none" }, alignItems: 'center' }}>
            <ModernMenuButton
              onClick={handleMenuToggle}
              aria-label="Toggle sidebar"
            >
              <MenuIcon />
            </ModernMenuButton>
          </Box>
        </HeaderActions>
      </ModernToolbar>
    </ModernHeaderWrapper>
  );
};

export default Header;